import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import MillsCard from "../../../../src/docs/components/millscard";
import Zoom from 'react-reveal/Zoom';
import Harris from "../../../../src/docs/assets/profiles/harris.jpg";
import Sellars from "../../../../src/docs/assets/profiles/sellars.jpg";
import Kitten from "../../../../src/docs/assets/profiles/kitten.jpg";
import Legate from "../../../../src/docs/assets/profiles/legate.jpg";
import Hellebuyck from "../../../../src/docs/assets/profiles/hellebuyck.jpg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  MillsCard,
  Zoom,
  Harris,
  Sellars,
  Kitten,
  Legate,
  Hellebuyck,
  React
};